import SoundEngine from './SoundEngine';

export default class Error extends SoundEngine {
  play () {
    const verb = this.fx.verb(0.2);

    const aOsc = this.osc.square();
    const aGain = this.fx.gain();
    const aFilter = this.fx.filter();

    const aLength = 0.3;
    aOsc.frequency.setValueAtTime(164.81, this.now);
    aGain.gain.setValueAtTime(0.5, this.now);
    aGain.gain.linearRampToValueAtTime(0.0001, this.now + (aLength / 3));
    aGain.gain.setValueAtTime(0.5, this.now + (aLength / 2));
    aGain.gain.linearRampToValueAtTime(0.0001, this.now + aLength);

    aOsc.connect(aGain);
    aGain.connect(aFilter);
    aFilter.connect(this.output);
    aFilter.connect(verb);

    aOsc.start();
    aOsc.stop(this.now + aLength);

    const bOsc = this.osc.square();
    const bGain = this.fx.gain();
    const bFilter = this.fx.filter();

    const bLength = 0.3;
    bOsc.frequency.setValueAtTime(110, this.now);
    bGain.gain.setValueAtTime(0.5, this.now);
    bGain.gain.linearRampToValueAtTime(0.0001, this.now + (bLength / 3));
    bGain.gain.setValueAtTime(0.5, this.now + (bLength / 2));
    bGain.gain.linearRampToValueAtTime(0.0001, this.now + bLength);

    bOsc.connect(bGain);
    bGain.connect(bFilter);
    bFilter.connect(this.output);
    bFilter.connect(verb);

    bOsc.start();
    bOsc.stop(this.now + bLength);

    const verbGain = this.fx.gain();
    verbGain.gain.setValueAtTime(0.2, this.now);
    verb.connect(verbGain);
    verbGain.connect(this.output);
  }
}
